<template>
  <b-container class="pv-policy-container">
    <b-card class="pdf-page shadow-sm border-0">
      <div class="pv-content">
        
        <h1 class="main-title text-center">
          2025 - Politique de confidentialité<br>
          (application mobile)
        </h1>

        <section>
          <h2 class="pdf-title">Quelle est l'utilité de notre Politique de confidentialité ?</h2>
          <p>
            Vitalliance SAS, qui gère l'application mobile Vitalliance PRO, accorde une grande
            importance à la protection et à la confidentialité de vos données personnelles qui
            représentent, pour nous, un gage de sérieux et de confiance.
          </p>
          <p>
            A ce titre, notre Politique de confidentialité des données personnelles témoigne précisément
            de notre volonté de faire respecter, au sein de Vitalliance SAS, les règles applicables en
            matière de protection des données personnelles et, plus particulièrement, celles du
            Règlement général sur la protection des Données ("RGPD").
          </p>
          <p>
            En particulier, notre Politique de confidentialité vise à vous informer sur la manière et les
            raisons pour lesquelles nous traitons vos données personnelles dans le cadre des services que
            nous vous fournissons.
          </p>
        </section>

        <section>
          <h2 class="pdf-title">A qui s'adresse notre Politique de confidentialité ?</h2>
          <p>
            Notre Politique de confidentialité s'adresse à vous, quel que soit votre lieu de domiciliation,
            dès lors que vous êtes âgé d'au moins 15 ans et que vous êtes utilisateurs de notre
            application mobile Vitalliance PRO.
          </p>
          <p>
            Si vous avez moins de l'âge légal détaillé ci-dessus, vous n'êtes pas autorisé à utiliser nos
            services sans le consentement préalable et explicite de l'un de vos parents ou du titulaire de
            l'autorité parentale qui doit nous être adressé par email à l'adresse
            donnees.personnelles@vitalliance.fr.
          </p>
          <p>
            Si vous pensez que nous détenons des données personnelles concernant vos enfants sans y
            avoir consenti, nous vous invitons à nous contacter à l'adresse dédiée détaillée ci-dessus.
          </p>
        </section>

        <section>
          <h2 class="pdf-title">Pourquoi traitons-nous vos données personnelles et sur quel fondement ?</h2>
          <p>Nous traitons vos données personnelles essentiellement pour les raisons suivantes :</p>
          <ul class="pdf-list">
            <li>Pour utiliser et bénéficier de notre service et de toutes ses fonctionnalités sur la base de nos conditions générales d'utilisation.</li>
            <li>Pour assurer la gestion des comptes utilisateurs (ex: création de compte, accès au service et suppression des comptes) sur la base de nos conditions générales d'utilisation.</li>
            <li>Pour échanger entre utilisateurs via notre messagerie interne mise à disposition sur la base de nos conditions générales d'utilisation.</li>
            <li>Pour échanger avec notre service support via notre chat/chatbot sur la base de nos conditions générales d'utilisation.</li>
            <li>Pour localiser votre position lorsque vous utilisez notre service afin de vous proposer un service personnalisé et adapté, sur la base de votre consentement.</li>
            <li>Pour pouvoir télécharger et importer des documents sur notre application mobile sur la base de nos conditions générales d'utilisation.</li>
            <li>Pour garantir et renforcer la sécurité et la qualité de nos services au quotidien (ex: statistiques, sécurité des données, etc.) sur la base des obligations légales pesant sur nous, de nos conditions générales d'utilisation et de notre intérêt légitime à assurer le bon fonctionnement de nos services.</li>
          </ul>
          <p>
            Vos données sont collectées directement auprès de vous dès lors que vous êtes utilisateur
            de notre application mobile Vitalliance PRO et nous nous engageons à ne traiter vos données
            que pour les raisons décrites précédemment.
          </p>
        </section>

        <section>
          <h2 class="pdf-title">Quelles données personnelles traitons-nous et pour combien de temps ?</h2>
          <p>Nous avons résumé ci-après les catégories de données personnelles ainsi que leurs durées respectives de conservation :</p>
          <ul class="pdf-list">
            <li>Données d'identification professionnelles (ex: nom, prénom, poste, entreprise, etc.) et coordonnées (ex: adresse email et téléphone professionnel, etc.) conservées pendant toute la durée de la fourniture du service à laquelle s'ajoutent les délais de prescriptions légaux qui sont généralement de 5 ans.</li>
            <li>Données de connexion (ex: logs, adresse IP, etc.) conservées pendant une durée de 1 an.</li>
            <li>Données de géolocalisation conservées pendant une durée de 2 mois.</li>
            <li>Données de santé conservées jusqu'à la suppression de votre compte.</li>
          </ul>
          <p>
            A l'expiration des durées de conservation applicables, la suppression de vos données
            personnelles est irréversible et nous ne pourrons plus vous les communiquer passé ce délai.
          </p>
          <p>
            Tout au plus, nous pouvons uniquement conserver des données anonymes à des fins de
            statistiques.
          </p>
          <p>
            Veuillez également noter qu'en cas de contentieux, nous avons pour obligation de conserver
            l'intégralité des données vous concernant durant toute la durée de traitement du dossier
            même après l'expiration de leurs durées de conservation décrites précédemment.
          </p>
        </section>

        <section>
          <h2 class="pdf-title">De quels droits disposez-vous pour contrôler l'usage de vos données personnelles ?</h2>
          <p>
            La réglementation applicable en matière de protection des données vous octroie des droits
            spécifiques que vous pouvez exercer, à tout moment et gratuitement, afin de contrôler
            l'usage que nous faisons de vos données.
          </p>
          <ul class="pdf-list">
            <li>Droit d'accès et de copie de vos données personnelles dès lors que cette demande n'est pas en contradiction avec le secret des affaires, la confidentialité, ou encore le secret des correspondances.</li>
            <li>Droit de rectification de données personnelles qui seraient erronées, obsolètes ou incomplètes.</li>
            <li>Droit de vous opposer au traitement de vos données personnelles lorsque celui-ci est fondé sur notre intérêt légitime, sauf si des motifs légitimes et impérieux justifient ce traitement et prévalent sur vos intérêts, droits et libertés.</li>
            <li>Droit de demander l'effacement ("droit à l'oubli") de vos données personnelles qui ne seraient pas essentielles au bon fonctionnement de nos services.</li>
            <li>Droit à la limitation de vos données personnelles qui permet de photographier l'utilisation de vos données en cas de contestation sur la légitimité d'un traitement.</li>
            <li>Droit à la portabilité de vos données qui vous permet de récupérer une partie de vos données personnelles afin de les stocker ou les transmettre facilement d'un système d'information à un autre.</li>
            <li>Droit de donner des directives sur le sort de vos données en cas de décès soit par votre intermédiaire, soit l'intermédiaire d'un tiers de confiance ou d'un ayant-droit.</li>
          </ul>
          <p>
            Pour qu'une demande soit prise en compte, il est impératif qu'elle soit effectuée directement
            par vous, ou votre représentant à l'adresse donnees.personnelles@vitalliance.fr.
          </p>
          <p>Les demandes ne peuvent pas émaner d'une autre personne que vous ou votre représentant.</p>
          <p>
            Nous pouvons donc vous demander la communication d'une preuve d'identité en cas de
            doute sur l'identité du demandeur, ainsi qu'une justification de la représentation.
          </p>
          <p>
            Nous répondrons à votre demande dans les meilleurs délais avec pour limite un délai
            maximum d'un mois à compter de sa réception, sauf si la demande est techniquement
            complexe ou si nous recevons de nombreuses demandes au même moment.
          </p>
          <p>Dans ce cas, le délai de réponse peut être de trois mois maximum.</p>
          <p>
            Veuillez noter que nous pouvons toujours refuser de répondre à toute demande excessive
            ou infondée notamment au regard de son caractère répétitif.
          </p>
        </section>

        <section>
          <h2 class="pdf-title">Qui peut avoir accès à vos données personnelles ?</h2>
          <p>
            Vos données personnelles sont traitées par nos équipes et par nos prestataires techniques
            dans l'unique but de faire fonctionner notre service.
          </p>
          <p>
            Nous précisons que nous contrôlons tous nos prestataires techniques avant de les recruter
            afin de s'assurer qu'ils respectent scrupuleusement les règles applicables en matière de
            protection des données personnelles.
          </p>
          <p>
            <strong>PAR AILLEURS, NOUS VOUS GARANTISSONS QUE NOUS NE TRANSFERONS OU NE VENDONS
            JAMAIS VOS DONNEES A DES TIERS OU A DES PARTENAIRES COMMERCIAUX.</strong>
          </p>
        </section>

        <section>
          <h2 class="pdf-title">Vos données personnelles peuvent-elles être transférées en dehors de l'Union européenne ?</h2>
          <p>
            Les données personnelles traitées par notre application mobile Vitalliance PRO sont
            exclusivement hébergées sur des serveurs situés au sein de l'Union européenne.
          </p>
          <p>
            Par ailleurs, nous faisons notre maximum pour n'utiliser que des outils techniques dont les
            serveurs sont également situés au sein de l'Union européenne.
          </p>
          <p>
            Si toutefois cela n'était pas le cas, nous veillons scrupuleusement à ce qu'ils mettent en œuvre les
            garanties appropriées requises pour assurer la confidentialité et la protection de vos données personnelles.
          </p>
        </section>

        <section>
          <h2 class="pdf-title">Comment protégeons-nous vos données personnelles ?</h2>
          <p>
            Nous mettons en œuvre les moyens techniques et organisationnels suivants pour garantir la
            sécurité de vos données personnelles au quotidien et, en particulier, pour lutter contre tout
            risque de destruction, perte, altération, ou divulgation.
          </p>

          <b-table-simple bordered fixed class="pdf-table mt-3">
            <b-thead>
              <b-tr>
                <b-th class="table-header-cell">Mesures de sécurité techniques</b-th>
                <b-th class="table-header-cell">Mesures de sécurité organisationnelles</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr>
                <b-td>Déconnexion automatique du compte utilisateur (côté "Back") après une période d'inactivité, Mots de passe complexes imposés aux utilisateurs (côté "Back") à la connexion, Mots de passe des utilisateurs (côté "Back") fréquemment modifiés, Protocole HTTPS, Tests d'intrusion à intervalles réguliers, Traçabilité des accès, Mots de passe des terminaux des équipes de Vitalliance SAS fréquemment modifiés, Système de limitation de tentatives d'accès pour les équipes de Vitalliance SAS, VPN pour les équipes de Vitalliance SAS, Duplication de la base de données utilisateurs sur des serveurs de secours</b-td>
                <b-td>Badge d'accès, Charte des systèmes d'information, Politique de gestion des habilitations et mots de passe, Procédure de gestion de violation de données, Procédure de gestion des droits des personnes, Règles de bonne conduite, Sensibilisation et formation des équipes 2 fois par an, Vidéoprotection dans les locaux</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </section>

        <section>
          <h2 class="pdf-title">Utilisons-nous des cookies lorsque vous naviguez sur notre application mobile ?</h2>
          <p>Nous vous garantissons que nous n'utilisons aucun cookie publicitaire pour le fonctionnement de cette application mobile.</p>
          <p>
            Plus encore, nous vous garantissons également qu'hormis des cookies techniques nécessaires
            au bon fonctionnement de notre application mobile, nous n'utilisons que des cookies
            statistiques considérés par les autorités de contrôle comme étant suffisamment
            protecteurs pour être exonérés de consentement et donc de bandeau cookies.
          </p>
          <p>A ce titre, vous ne pouvez pas vous opposer à l'utilisation de ces cookies statistiques.</p>
          <p>
            Vous pouvez toutefois vous opposer au dépôt de cookies techniques sur votre terminal à
            l'aide des paramètres de votre navigateur en suivant les instructions suivantes: Chrome,
            Microsoft Edge, Safari, Firefox et Opera.
          </p>
        </section>

        <section>
          <h2 class="pdf-title">Qui pouvez-vous contacter pour obtenir plus d'informations sur l'utilisation de vos données personnelles ?</h2>
          <p>
            Pour garantir au mieux la protection et l'intégrité de vos données, nous avons officiellement
            nommé un Délégué à la protection des données ("DPO") indépendant auprès de notre
            autorité de contrôle.
          </p>
          <p>
            Vous pouvez à tout moment et gratuitement contacter notre DPO à l'adresse
            donnees.personnelles@vitalliance.fr afin d'obtenir plus d'informations ou de détails sur la
            manière dont nous traitons vos données.
          </p>
        </section>

        <section>
          <h2 class="pdf-title">Comment pouvez-vous contacter la CNIL?</h2>
          <p>
            Vous pouvez à tout moment contacter la "Commission nationale de l'informatique et des
            libertés" ou "CNIL" aux coordonnées suivantes: Service des plaintes de la CNIL, 3 place de
            Fontenoy - TSA 80751, 75334 Paris Cedex 07 ou par téléphone au 01.53.73.22.22.
          </p>
        </section>

        <section class="mb-5">
          <h2 class="pdf-title">La Politique de confidentialité peut-elle être modifiée ?</h2>
          <p>
            Nous sommes susceptibles de modifier notre Politique de confidentialité à tout moment pour
            l'adapter aux nouvelles exigences légales ainsi qu'aux nouveaux traitements que nous
            pourrions mettre en œuvre dans le futur.
          </p>
        </section>
      </div>

      <div class="text-center mt-5 mb-4 no-print">
        <b-button class="btn-close-pdf" @click="goBack">Fermer</b-button>
      </div>
    </b-card>
  </b-container>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  methods: {
    goBack() {
      if (window.history.length > 2) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'home' });
      }
    }
  }
}
</script>

<style scoped>
.pv-policy-container {
  max-width: 900px;
  background-color: #f5f5f5;
  padding: 40px 15px;
}

.pdf-page {
  background-color: white !important;
  border-radius: 2px;
  padding: 60px 70px;
  color: #333;
}

.main-title {
  font-weight: bold;
  font-size: 2rem;
  color: #EC5F71;
  margin-bottom: 40px;
  line-height: 1.2;
}

.pdf-title {
  color: #EC5F71;
  font-weight: bold;
  font-size: 1.3rem;
  margin-top: 2.5rem;
  margin-bottom: 1.2rem;
  line-height: 1.3;
}

.pv-content {
  font-family: Arial, sans-serif;
  text-align: justify;
  line-height: 1.6;
}

.pdf-list {
  padding-left: 1.8rem;
  margin-bottom: 1.5rem;
}

.pdf-list li {
  margin-bottom: 12px;
}

/* Tableau bleu comme demandé */
.pdf-table {
  border: 1px solid #004a99 !important;
  margin-top: 25px;
}

.table-header-cell {
  background-color: #004a99 !important;
  color: white !important;
  font-weight: bold;
  padding: 12px !important;
  text-align: center;
}

.pdf-table td {
  border: 1px solid #004a99 !important;
}

.btn-close-pdf {
  background-color: #EC5F71;
  border-color: #EC5F71;
  color: white;
  padding: 12px 50px;
  font-weight: bold;
}

@media print {
  .no-print { display: none; }
  .pdf-page { box-shadow: none; padding: 0; border: none; }
}
</style>